var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApplicationsHover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.799805 2.29961C0.799805 1.63687 1.33706 1.09961 1.9998 1.09961H19.9998C20.6625 1.09961 21.1998 1.63687 21.1998 2.29961V24.2996C21.1998 24.9624 20.6625 25.4996 19.9998 25.4996H1.9998C1.33706 25.4996 0.799805 24.9624 0.799805 24.2996V2.29961ZM1.9998 1.99961C1.83412 1.99961 1.6998 2.13392 1.6998 2.29961V24.2996C1.6998 24.4653 1.83412 24.5996 1.9998 24.5996H19.9998C20.1655 24.5996 20.2998 24.4653 20.2998 24.2996V2.29961C20.2998 2.13392 20.1655 1.99961 19.9998 1.99961H1.9998Z",
    fill: "#2D2943"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7998 7.49961V6.59961H18.1998V7.49961H10.7998Z",
    fill: "#2D2943"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7998 11.4996V10.5996H15.1998V11.4996H10.7998Z",
    fill: "#2D2943"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7998 15.4996V14.5996H18.1998V15.4996H10.7998Z",
    fill: "#2D2943"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7998 19.4996V18.5996H14.1998V19.4996H10.7998Z",
    fill: "#2D2943"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.1998 8.29961C9.1998 9.51464 8.21483 10.4996 6.9998 10.4996C5.78478 10.4996 4.7998 9.51464 4.7998 8.29961C4.7998 7.08458 5.78478 6.09961 6.9998 6.09961C8.21483 6.09961 9.1998 7.08458 9.1998 8.29961ZM6.9998 9.59961C7.71777 9.59961 8.2998 9.01758 8.2998 8.29961C8.2998 7.58164 7.71777 6.99961 6.9998 6.99961C6.28183 6.99961 5.6998 7.58164 5.6998 8.29961C5.6998 9.01758 6.28183 9.59961 6.9998 9.59961Z",
    fill: "#2D2943"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4499 13.4996H9.5499V13.2996C9.5499 12.9448 9.33423 12.5682 8.87161 12.2598C8.81446 12.2217 8.7541 12.1851 8.6907 12.1503C8.24567 11.9056 7.65727 11.7496 6.9999 11.7496C6.18521 11.7496 5.48046 11.9888 5.02112 12.3358C4.68002 12.5934 4.49848 12.8886 4.45854 13.1753C4.45279 13.2166 4.4499 13.2581 4.4499 13.2996V13.4996H3.5498L3.5499 13.298C3.55009 13.1035 3.58128 12.9161 3.63879 12.7381C3.78293 12.2921 4.08987 11.9113 4.47868 11.6176C4.55894 11.557 4.64328 11.4996 4.73126 11.4455C5.34572 11.0678 6.14391 10.8496 6.9999 10.8496C7.9048 10.8496 8.74436 11.0933 9.37084 11.511C9.60595 11.6677 9.81579 11.8527 9.9867 12.0623C10.0939 12.1938 10.1861 12.3354 10.2593 12.4859C10.299 12.5674 10.3331 12.6516 10.3611 12.7381C10.3913 12.8315 10.4142 12.9276 10.4292 13.026C10.4429 13.1155 10.4499 13.2068 10.4499 13.2996V13.4996Z",
    fill: "#2D2943"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8002 2.09961L23.7002 2.09961L23.7002 24.4996L22.8002 24.4996L22.8002 2.09961Z",
    fill: "#2D2943"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5498 13.0996H10.4498V13.9996H3.5498V13.0996Z",
    fill: "#2D2943"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicationsHover);
export default __webpack_public_path__ + "static/media/applications-hover.6a8a154a.svg";
export { ForwardRef as ReactComponent };